<template>
    <div class="d-flex flex-column justify-content-center h-3em text-center" :class="[sizeClass]">
        <div :class="{'text-muted': value === 0}" class="text-nowrap">
            <span v-if="prefix" v-text="prefix"/>
            <span>{{ displayValue }}</span>
            <span v-if="suffix" v-text="suffix"/>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: Number,
        prefix: String,
        suffix: String,
        sizeClass: {
            type: String,
            default: 'text-lg',
        },
        decimals: {
            type: Number,
            default: -1,
        },
    },

    computed: {
        displayValue() {
            if (this.decimals === -1) {
                return this.value
            }

            return this.value.toFixed(this.decimals)
        },
    },
}
</script>
